import { AutocompleteInput, DateInput, ReferenceInput, SelectInput, TextInput } from "react-admin";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { NeedSadaratFields } from "@/components/raza/NeedSadaratFields";
import { RazaEventItsPickerInput } from "@/components/raza/RazaEventItsPickerInput";
import RazaEventITSLookup from "@/components/raza/RazaEventITSLookup";
import { RazaEventVenueAddressField } from "@/components/raza/RazaEventVenueAddressField";
import { GoogleCalendarBusyPreview } from "./GoogleCalendarBusyPreview";
import { MAJLIS_START_TIME_CHOICES } from "@/utils/raza-event-time";

const typeChoices = [
  { id: "Jaman", name: "Jaman" },
  { id: "Salawaat", name: "Salawaat" },
];

export function RazaEventOhbatFormFields() {
  return (
    <Grid container spacing={2}>
      <Grid
        sx={{
          pr: { md: 2 },
          borderRight: { md: "1px solid" },
          borderColor: "divider",
        }}
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography variant="overline" color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
          Majlis & contacts
        </Typography>
        <RazaEventITSLookup source="hostItsNo" label="Host ITS" />
        <TextInput
          source="hostName"
          label="Host name"
          fullWidth
          helperText="Auto-filled when the host ITS is in the directory; otherwise enter the name manually"
        />
        <SelectInput source="ohbatType" choices={typeChoices} fullWidth />
        <NeedSadaratFields />
        <ReferenceInput
          source="khidmatguzarItsNo"
          reference="itsdata"
          filter={{ forKhidmatguzarPicker: true }}
          allowEmpty
          perPage={50}
        >
          <AutocompleteInput
            optionText={(r) => `${r.ITS_ID} — ${r.Full_Name || ""}`}
            optionValue="ITS_ID"
            label="Khidmatguzar (optional)"
            helperText="Tolobatul Kulliyatil Mumineen only; validated on save"
            filterToQuery={(q) => ({ q: q || "", forKhidmatguzarPicker: true })}
            emptyText="— None —"
            debounce={300}
            fullWidth
          />
        </ReferenceInput>
        <RazaEventItsPickerInput
          source="zakereenItsNo"
          label="Zakereen (optional)"
          helperText="Search by name or ITS; must exist in itsdata"
        />
        <DateInput source="date" label="Majlis date" fullWidth />
        <SelectInput
          source="startTime"
          choices={MAJLIS_START_TIME_CHOICES}
          label="Time"
          fullWidth
          helperText="15-minute steps"
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography variant="overline" color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
          Venue & notes
        </Typography>
        <RazaEventVenueAddressField />
        <TextInput source="mobileNo" label="Contact mobile" fullWidth />
        <TextInput source="notes" label="Notes" fullWidth multiline minRows={4} />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <GoogleCalendarBusyPreview />
      </Grid>
    </Grid>
  );
}
